const buildMessageBody = ({ name, email, phone, message, technology, extra }) => {
  const lines = [
    "Hi,",
    "",
    `Name: ${name || "-"}`,
    `Email: ${email || "-"}`,
    `Phone: ${phone || "-"}`,
    `Technology: ${technology || "-"}`,
    `Message: ${message || "-"}`,
  ]

  if (extra && typeof extra === "object") {
    Object.entries(extra).forEach(([key, value]) => {
      lines.push(`${key}: ${value || "-"}`)
    })
  }

  return lines.join("\n")
}

const getBaseUrls = () => {
  const envContact = (process.env.GATSBY_CONTACT_API_URL || "").replace(/\/+$/, "")
  const envStrapi = (process.env.GATSBY_STRAPI_URL || "").replace(/\/+$/, "")
  const hostname =
    typeof window !== "undefined" && window.location ? window.location.hostname : ""
  const isLocal = hostname === "localhost" || hostname === "127.0.0.1"

  if (isLocal) {
    return [`${envContact || envStrapi || "http://localhost:1337"}/contact`]
  }

  // Keep production requests same-origin to avoid CORS from preview/alternate domains.
  return ["/api/contact", "/contact"]
}

export const submitLeadForm = async payload => {
  const name = (payload?.name || "").trim()
  const email = (payload?.email || "").trim()
  const phone = (payload?.phone || "").trim()
  const message = (payload?.message || "").trim()
  const technology = (payload?.technology || "").trim()
  const extra = payload?.extra || {}
  const file = payload?.file || null

  if (!name || !email || !message) {
    return { ok: false, error: "Name, email and message are required." }
  }

  const messageBody = buildMessageBody({ name, email, phone, message, technology, extra })

  const requestBody = {
    name,
    email,
    phone,
    message,
    technology,
    messageBody,
    ...extra,
  }

  const endpoints = getBaseUrls()

  let lastError = "Could not submit form."
  for (const endpoint of endpoints) {
    try {
      const hasFile =
        typeof File !== "undefined" && file instanceof File && file.size > 0
      const body = hasFile
        ? (() => {
            const formData = new FormData()
            Object.entries(requestBody).forEach(([key, value]) => {
              formData.append(key, value == null ? "" : String(value))
            })
            formData.append("file", file)
            return formData
          })()
        : JSON.stringify(requestBody)
      const headers = hasFile ? {} : { "Content-Type": "application/json" }

      const res = await fetch(endpoint, {
        method: "POST",
        headers,
        body,
      })

      const contentType = res.headers.get("content-type") || ""
      const rawBody = await res.text()
      let data = {}
      if (rawBody) {
        try {
          data = JSON.parse(rawBody)
        } catch {
          data = contentType.includes("application/json") ? {} : {}
        }
      }

      if (res.ok && data?.success !== false) {
        return { ok: true }
      }

      lastError = data?.error || data?.message || `Request failed (${res.status})`
    } catch (err) {
      lastError = err?.message || "Network error."
    }
  }

  return { ok: false, error: lastError }
}
